import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getUsers } from "../../../../services/apiUsers";

export function useUsers({
    filter,
    fields,
    include,
    includeFields,
    perPage,
    searchValue,
    sortBy,
    page,
    filterAndSortAndPageQuery,
} = {}) {
    const queryClient = useQueryClient();

    const {
        data: users,
        isPending,
        isSuccess,
    } = useQuery({
        queryKey: [
            "users",
            page,
            perPage,
            filter,
            fields,
            include,
            includeFields,
            searchValue,
            sortBy,
            filterAndSortAndPageQuery,
        ],
        queryFn: () =>
            getUsers({
                page,
                perPage,
                filter,
                fields,
                include,
                includeFields,
                searchValue,
                sortBy,
                filterAndSortAndPageQuery,
            }),
    });

    const totalPages = Math.ceil(users?.meta?.total / users?.meta?.per_page);

    // PRE - FETCHING;
    if (isSuccess && page < totalPages) {
        queryClient.prefetchQuery({
            queryKey: [
                "users",
                page,
                perPage,
                filter,
                fields,
                include,
                includeFields,
                searchValue,
                sortBy,
                filterAndSortAndPageQuery,
            ],
            queryFn: () =>
                getUsers({
                    page: page++,
                    perPage,
                    filter,
                    fields,
                    include,
                    includeFields,
                    searchValue,
                    sortBy,
                    filterAndSortAndPageQuery,
                }),
        });
    }

    if (isSuccess && page > 1) {
        queryClient.prefetchQuery({
            queryKey: [
                "users",
                page,
                perPage,
                filter,
                fields,
                include,
                includeFields,
                searchValue,
                sortBy,
                filterAndSortAndPageQuery,
            ],
            queryFn: () =>
                getUsers({
                    page: page--,
                    perPage,
                    filter,
                    fields,
                    include,
                    includeFields,
                    searchValue,
                    sortBy,
                    filterAndSortAndPageQuery,
                }),
        });
    }

    return { isPending, users };
}
